import React, { memo } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Card, CardBody, Col } from "reactstrap"

const BlockedCoupon = ({
  title = "",
  colSize = 3,
  store_details = {},
  store_domain = "",
  store_status = "",
  is_plan = false
}) => {
  const linkProps = store_domain ? {
    search: `?store=${encodeURIComponent(store_domain)}`,
    state: { data: { store_domain, store_details, store_status } }
  } : {
    state: { data: { store_domain, store_details, store_status } }
  };

  return (
    <Col xl={colSize}>
      <Card>
        <CardBody>
          <div className="d-flex flex-wrap d-between-flex">
            <h3 className="card-title mb-3 me-2">{title}</h3>
            <Link
              to={{
                pathname: is_plan ? "/plan-info" : "/blocked-coupon",
                ...linkProps
              }}
            >
              <i className="fa fa-eye"></i> View
            </Link>
          </div>
          {is_plan && (
            <span>
              <h6 className="mb-3">{store_details.plan || ''}</h6>
              <span
                className="mb-3"
                style={{
                  color: store_details.plan_status === 'ACTIVE' ? 'green' : 'red',
                  fontWeight: 'bold'
                }}
              >
                {store_details.plan_status || ''}
              </span>
            </span>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

BlockedCoupon.propTypes = {
  title: PropTypes.string,
  colSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  store_details: PropTypes.object,
  store_domain: PropTypes.string,
  store_status: PropTypes.string,
  is_plan: PropTypes.bool,
}

export default memo(BlockedCoupon)
